
import ticketUsers from "../../../svg/ticket.png";
import ticketAcademic from "../../../svg/ticketGreen.png";
import ticketSchool from "../../../svg/ticketPurple.png";
import {useTranslation} from "react-i18next";
import button1 from "../../../svg/button.png";
import { Link } from "react-router-dom";

const TicketAvailability = (props) => {
  const [t, ] = useTranslation("global");

  let ticket = ticketUsers;
  let color = "white";
  let comingColor = "white";
  if (props.page === "academic") {
    ticket = ticketAcademic;
    color = "#12d7a6";
    comingColor = "black";
  } else if (props.page === "school") {
    ticket = ticketSchool;
    color = "#6832c7";
    comingColor = "black";
  }

  let button = {
    backgroundImage: `url(${button1})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    padding: "4px",
  };

  return (
      <>
          <div
            style={{ fontFamily: "Bebas Neue", color: color }}
            className="text-center text-5xl uppercase"
          >
            {t("home.tickets")}
          </div>
          <img src={ticket} className="aflex justify-center w-80" alt="logo" style={{marginLeft:'auto', marginRight:'auto'}} />
          
          <div
            style={{ fontFamily: "Poppins", textAlignLast: "center", color: comingColor }}
            className="text-justify text-base lg:w-1/2 w-11/12 place-items-center"
            id="schedule"
          >
            {t("home.tickets-text-player")}

          </div>
          
          {props.page === "users" && (
            <Link
              style={{ fontFamily: "Bebas Neue" }}
              to= {"/tickets"}
              id="buyTicket"
              className="pt-10"
            >
              <button
                className="text-white w-48 h-20 text-center uppercase text-xl"
                style={{...button, width:"200px", height:"60px"}}
              >
                {t("home.buyticket")}
              </button>
            </Link>
          )}
          {props.page === "academic" && (
            <Link
              style={{ fontFamily: "Bebas Neue", width:"50%" }}
              to= {"/tickets"}
              id="buyTicket"
              className="pt-10"
            >
              <button
                className="text-white bg-gradient-to-r from-green-white to-green-dark hover:bg-green-dark focus:ring-4 focus:outline-none focus:bg-lime-900 font-medium text-xl w-full px-5 py-4 text-center"
              >
                {t("home.buyticket")}
              </button>
            </Link>
          )}
          {props.page === "school" && (
            <Link
              style={{ fontFamily: "Bebas Neue", width:"100%", textAlign:"center" }}
              to= {"/tickets"}
              id="buyTicket"
              className="pt-10"
            >
              <button
                className="text-white uppercase text-sm sm:text-base md:text-lg lg:text-xl w-40 sm:w-44 md:w-48 h-12 sm:h-14 md:h-16 bg-[#6832c7] rounded-full border-2 border-[#6832c7]"
                style={{ fontFamily: "Bebas Neue", width:"50%", marginLeft:"auto", marginRight:"auto" }}
              >
                {t("home.buyticket")}
              </button>
            </Link>
          )}
          {/*
          <p className="text-center uppercase text-3xl font-bold" style={{color:comingColor}}>
            {t("home.coming_october")}
          </p>*/}
      </>
  );
};

export default TicketAvailability;
